module.exports = __webpack_public_path__ + "img/Logo-22.a3171693.svg";